import React, { ComponentProps } from 'react';
import IUrl from '../../types/IUrl';
import { UserProfileSelection } from '../../_lib/components/UserProfileSelection/UserProfileSelection';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';

type UserAnonymousProps = { loginUrl?: IUrl; selfRegistrationIsActive: boolean };

function UserAnonymous({ loginUrl, selfRegistrationIsActive }: UserAnonymousProps) {
  const { t } = useSonTranslation('UserAnonymous');
  const loginLinkText = selfRegistrationIsActive ? t('loginTextWithRegistration') : t('loginText');
  return (
    <UserProfileSelection
      intro={t('intro')}
      helpText={t('helpText')}
      loginLink={loginUrl?.url}
      loginLinkText={loginLinkText}
    />
  );
}
export const UserAnonymousBlock = asFetchableBlock(UserAnonymous, BlockType.useranonymous);
export type UserAnonymousBlock = ComponentProps<typeof UserAnonymousBlock>;
